import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'bs-combo-bet-linear-edit-toggle',
    templateUrl: './combo-bet-linear-edit-toggle.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./combo-bet-linear-edit-toggle.component.scss'],
    standalone: false,
})
export default class ComboBetLinearEditToggleComponent {
    @Input() expanded: boolean;
    @Input() isEpcotEnabled: boolean;
    @Input() selectedPicksCount: number;
    @Input() totalPicksCount: number;
    @Output() expandToggled = new EventEmitter<void>();

    constructor(public sitecore: Sitecore) {}

    toggleExpand(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();

        this.expandToggled.emit();
    }

    get toggleText(): string {
        return !this.isEpcotEnabled
            ? this.expanded
                ? this.sitecore.betslip.linear.MultiCollapse
                : this.sitecore.betslip.linear.MultiExpand
            : this.sitecore.betslip.linear.MultiExpand;
    }

    get pickSelectionText(): string {
        if (!this.isEpcotEnabled || this.totalPicksCount === this.selectedPicksCount) {
            return '';
        }

        return `(${this.selectedPicksCount}/${this.totalPicksCount})`;
    }
}
